/** @jsx jsx */
import { jsx } from "theme-ui";
import { FunctionComponent } from "react";

export const Hologram: FunctionComponent<{
  className?: string;
}> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 512 512">
      <path
        className="white"
        d="M360.58,427.51H151.42a41.83,41.83,0,0,1,41.83-41.83h125.5A41.83,41.83,0,0,1,360.58,427.51Z"
      />
      <path
        className="skyBlueLightest"
        d="M256,84.48l-62.75,36.58v72.65L256.16,230l63.29-36.32V121.06Z"
      />
      <path d="M321.19,118,257.74,81.46a3.54,3.54,0,0,0-3.51,0l-62.74,36.58a3.51,3.51,0,0,0-1.73,3v72.65a3.53,3.53,0,0,0,1.74,3l62.92,36.32a3.54,3.54,0,0,0,3.48,0l63.25-36.29a3.54,3.54,0,0,0,1.78-3V121.06A3.49,3.49,0,0,0,321.19,118Zm-124.45,5,55.77-32.51v64.83l-55.77,32.29Zm59.43,103-56-32.3,55.8-32.3,56.43,32.31ZM316,187.7l-56.47-32.33V90.51L316,123.07Z" />
      <path d="M110.57,143.88a3.76,3.76,0,0,0-1-.14,3.56,3.56,0,0,0-1.66.42,3.49,3.49,0,0,0-1.4,4.73L211.1,341.33a3.49,3.49,0,0,0,4.73,1.4,3.49,3.49,0,0,0,1.4-4.73L112.64,145.56A3.47,3.47,0,0,0,110.57,143.88Z" />
      <path d="M399.36,145.56,294.77,338a3.49,3.49,0,0,0,6.13,3.33L405.48,148.89a3.48,3.48,0,0,0-1.4-4.72,3.39,3.39,0,0,0-2.65-.28A3.45,3.45,0,0,0,399.36,145.56Z" />
      <path d="M259.49,272.73a3.49,3.49,0,0,0-7,0v66.93a3.49,3.49,0,1,0,7,0Z" />
      <path d="M318.75,382.19H193.25a45.37,45.37,0,0,0-45.32,45.32,3.49,3.49,0,0,0,3.49,3.49H360.58a3.49,3.49,0,0,0,3.49-3.49A45.37,45.37,0,0,0,318.75,382.19ZM154.82,424l.84-4.18a38.42,38.42,0,0,1,37.59-30.68h125.5a38.48,38.48,0,0,1,37.58,30.68l.85,4.18Z" />
    </svg>
  );
};
